import { styled } from "styled-components";
const Subheading = styled("p")(
  ({ theme }) => ({
    color: theme.color.black7,
    fontSize: theme.fontSize.default,
    fontWeight: theme.fontWeight.normal,
    lineHeight: theme.lineHeight.default,
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis"
  }),
  ({ noWrap }) => noWrap ? {
    whiteSpace: "nowrap"
  } : void 0
);
export {
  Subheading
};
